export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-9020HD_white-49ae0926b80ee09fa541ea17e00e6547.webp";